<div class="dialog-box">
    <div class="mat-dialog-title" mat-dialog-title>
        <div id="lblHeading">
            Online Viewer
            <i class="fa fa-times-circle pull-right" (click)="togglePopupDialog()" aria-hidden="true"></i>
        </div>
    </div>
</div>
<div mat-dialog-content class="">
    <iframe width="100%" height="100%" frameBorder="2" [src]="urlSafe"></iframe>
</div>